import Vue from 'vue';
import clientTransformer from './../../transformers/client';
import paginationTransformer from '../../transformers/pagination';

const success = ({ data }, resolve) => {
  const items = clientTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  resolve({ items, pagination });
};

const failed = (error, reject) => reject(error);

export default (campaignId, page = 1, limit = 50) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`news_campaigns/${campaignId}/clients?page=${page}&limit=${limit}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/clientCampaign/items.js